import { gql } from '__generated__/gql';

export const REFRESH_COGNITO_TOKENS = gql(/* GraphQL */ `
  mutation RefreshCognitoTokens($input: RefreshCognitoTokensInput!) {
    refreshCognitoTokens(input: $input) {
      success
      error
      data {
        ...AuthSession
      }
    }
  }
`);
